import {
  avertaStdRegular,
  avertaStdSemibold,
  avertaStdBold,
  dinProMedium,
  dinProRegular,
  dinProBold,
  dinProBlack,
} from './fontPaths'

const AvertaStdRegular = {
  fontFamily: 'AvertaStd',
  fontStyle: 'normal',
  fontWeight: 400,
  fontDisplay: 'swap',
  src: `
    url(${avertaStdRegular}) format('woff')
  `,
}

const AvertaStdSemibold = {
  fontFamily: 'AvertaStd',
  fontStyle: 'normal',
  fontWeight: 600,
  fontDisplay: 'swap',
  src: `
    url(${avertaStdSemibold}) format('woff')
  `,
}

const AvertStdBold = {
  fontFamily: 'AvertaStd',
  fontStyle: 'normal',
  fontWeight: 700,
  fontDisplay: 'swap',
  src: `
    url(${avertaStdBold}) format('woff')
  `,
}

const DINProRegular = {
  fontFamily: 'DINPro',
  fontStyle: 'normal',
  fontWeight: 400,
  fontDisplay: 'swap',
  src: `
    url(${dinProRegular}) format('woff')
  `,
}

const DINProMedium = {
  fontFamily: 'DINPro',
  fontStyle: 'normal',
  fontWeight: 500,
  fontDisplay: 'swap',
  src: `
    url(${dinProMedium}) format('woff')
  `,
}

const DINProBold = {
  fontFamily: 'DINPro',
  fontStyle: 'normal',
  fontWeight: 700,
  fontDisplay: 'swap',
  src: `
    url(${dinProBold}) format('woff')
  `,
}

const DINProBlack = {
  fontFamily: 'DINPro',
  fontStyle: 'normal',
  fontWeight: 900,
  fontDisplay: 'swap',
  src: `
    url(${dinProBlack}) format('woff')
  `,
}

export default [AvertaStdRegular, AvertaStdSemibold, AvertStdBold, DINProMedium]

const mehrAchtunugFontFamilies = [
  DINProRegular,
  DINProMedium,
  DINProBold,
  DINProBlack,
]

export { mehrAchtunugFontFamilies }
